<template>
  <v-container fluid class="pa-6">
    
    <v-row no-gutters class="mb-4">
      <v-col cols="12">
        <v-btn 
          text 
          dark 
          x-small 
          class="grey--text text-none px-0 font-weight-black" 
          @click="$router.push({ name: rutaInventario('stock') })"
        >
          <v-icon left x-small>mdi-arrow-left</v-icon>
          VOLVER AL PANEL DE PRODUCTOS
        </v-btn>
      </v-col>
    </v-row>

    <v-row align="end" class="mb-8 px-2">
      <v-col>
        <div class="d-flex align-center mb-1">
          <v-icon x-small color="grey darken-1" class="mr-2">mdi-layers-outline</v-icon>
          <span class="grey--text text-overline font-weight-black letter-spacing-1" style="line-height: 1">Módulo Sucursal</span>
        </div>
        <h1 class="white--text text-h4 font-weight-black">
          Historial de Inventarios
        </h1>
      </v-col>
      
      <v-col cols="auto">
        <v-btn
          color="white"
          class="black--text text-none font-weight-black rounded-xl px-6"
          elevation="0"
          height="44"
          @click="$router.push({ name: rutaInventario('nuevo') })"
        >
          <v-icon left size="20">mdi-plus</v-icon> NUEVO INFORME
        </v-btn>
      </v-col>
    </v-row>

    <v-row dense class="mb-6 px-1" align="center">
      <v-col cols="auto">
        <v-menu
          v-model="menuFecha"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <div 
              v-on="on" 
              v-bind="attrs" 
              class="filter-pill pa-2 px-4 rounded-pill d-flex align-center cursor-pointer"
              :class="filtros.fecha ? 'active' : ''"
            >
              <v-icon x-small :color="filtros.fecha ? 'black' : 'grey'" class="mr-2">mdi-calendar-edit</v-icon>
              <span class="text-caption font-weight-black">
                {{ filtros.fecha ? formatFechaDisplay(filtros.fecha) : 'FILTRAR POR FECHA' }}
              </span>
              <v-icon v-if="filtros.fecha" x-small class="ml-2" @click.stop="filtros.fecha = null; aplicarFiltros()">mdi-close</v-icon>
            </div>
          </template>
          <v-date-picker
            v-model="filtros.fecha"
            @input="menuFecha = false; aplicarFiltros()"
            color="grey darken-3"
            dark
            header-color="#111"
            :max="new Date().toISOString().substr(0, 10)"
          />
        </v-menu>
      </v-col>

      <v-col cols="auto">
        <div class="filter-pill pa-2 px-4 rounded-pill d-flex align-center" :class="filtros.estado ? 'active' : ''">
          <v-icon x-small :color="filtros.estado ? 'black' : 'grey'" class="mr-2">mdi-circle-medium</v-icon>
          <select 
            v-model="filtros.estado" 
            @change="aplicarFiltros"
            class="native-select-clean text-caption font-weight-black"
          >
            <option :value="null">ESTADO: TODOS</option>
            <option v-for="e in estados" :key="e" :value="e">{{ e.toUpperCase() }}</option>
          </select>
        </div>
      </v-col>

      <v-col cols="auto" v-if="filtros.fecha || filtros.estado">
        <v-btn text color="grey darken-2" x-small class="ml-2 font-weight-black" @click="resetFiltros">
          LIMPIAR FILTROS
        </v-btn>
      </v-col>
    </v-row>

    <v-divider class="grey darken-4 mb-8 mx-2"></v-divider>

    <div class="router-content-area">
      <router-view :filtros="filtros" />
    </div>

  </v-container>
</template>

<script>
import inventarioMixin from "@/mixins/inventario.mixin";
import moment from "moment";

export default {
  mixins: [inventarioMixin],
  name: "SucursalInventarios",
  data() {
    return {
      filtros: {
        fecha: null,
        estado: null,
      },
      menuFecha: false,
      estados: ["Abierto", "Cerrado", "Anulado"],
    };
  },
  methods: {
    aplicarFiltros() {
      // Como router-view pasa los filtros por props, 
      // el componente hijo los recibirá automáticamente vía watch.
    },
    resetFiltros() {
      this.filtros.fecha = null;
      this.filtros.estado = null;
    },
    formatFechaDisplay(fecha) {
      return moment(fecha).format("DD MMM, YYYY").toUpperCase();
    }
  },
};
</script>

<style scoped>
.filter-pill {
  background-color: #1a1a1a;
  color: #888;
  border: 1px solid #333;
  transition: all 0.2s ease;
  height: 38px;
  user-select: none;
}

.filter-pill:hover {
  border-color: #444;
  background-color: #222;
}

.filter-pill.active {
  background-color: white;
  color: black;
  border-color: white;
}

.native-select-clean {
  background: transparent;
  border: none;
  color: inherit;
  outline: none;
  cursor: pointer;
  font-family: inherit;
}

.native-select-clean option {
  background-color: #1a1a1a;
  color: white;
}

.letter-spacing-1 {
  letter-spacing: 1.2px;
}

h1 {
  letter-spacing: -1px !important;
}

.router-content-area {
  min-height: 400px;
}
</style>